import { Component, OnInit } from '@angular/core';
import { HelperService } from '../service/helper/helper.service';
import { Router } from '@angular/router';
import { MatGridListModule, MatDialog, MatDialogConfig } from '@angular/material/';

import { ModalComponent } from '../modal/modal.component';
import Swal from "sweetalert2";


@Component({
  selector: 'app-export',
  templateUrl: './export.component.html',
  styleUrls: ['./export.component.css']
})
export class ExportComponent implements OnInit {
  public seed;
  public passPhrase;
  public locked = true;
  public raswSeed;
  constructor(public dialog: MatDialog,public router: Router, public helper: HelperService) { }

  ngOnInit() {}

  route(linkName) {
    const link = ['/' + linkName];
    this.router.navigate(link);
  }
  reveal() {
    let decrypted = this.helper.decrypt(this.passPhrase);
    if (!decrypted) {
      Swal.fire({
        type: 'error',
        title: 'Oops...',
        text: 'Wrong Key'
      })
      // alert("Can't decrypt with given pass phrase");
    }
    else {
      let walletObj = JSON.parse(window.localStorage.getItem('wallet_info'));
      let ExpoWallet = JSON.stringify({seed: decrypted,
        walletObj});
      console.log(ExpoWallet)
      this.seed = decrypted.split(" ", 12)
      this.raswSeed = ExpoWallet;
      this.locked = false;
    }
  }
  downloadAsText() {
    this.helper.saveAsFile(this.raswSeed);
  }

  openDialog() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      id: 1
    };
    dialogConfig.minWidth='300px'
    dialogConfig.position = {
      top:'68px',
      right: '0',
    };
    this.dialog.open(ModalComponent, dialogConfig);
  }

}



